import type { SkyscannerSonarCommonV1Enums } from '@skyscanner-internal/sonar-web-http-client';
import type { PriceStatus } from '@web-platform/shared-universal-types/src/redux/state/entities/flights/itineraries';

type UpdateStatus = SkyscannerSonarCommonV1Enums.UpdateStatus;

export const sonarUpdateStatus: {
  [Status in UpdateStatus]: Status;
} = {
  UPDATE_STATUS_UNSPECIFIED: 'UPDATE_STATUS_UNSPECIFIED',
  UPDATE_STATUS_PENDING: 'UPDATE_STATUS_PENDING',
  UPDATE_STATUS_CURRENT: 'UPDATE_STATUS_CURRENT',
  UPDATE_STATUS_UNAVAILABLE: 'UPDATE_STATUS_UNAVAILABLE',
  UPDATE_STATUS_FAILED: 'UPDATE_STATUS_FAILED',
  UPDATE_STATUS_ESTIMATED: 'UPDATE_STATUS_ESTIMATED',
};

export type UpdateStatusMap = {
  [key in Exclude<UpdateStatus, 'UPDATE_STATUS_UNSPECIFIED'>]: PriceStatus;
};

export const agentsUpdateStatusMap: UpdateStatusMap = {
  UPDATE_STATUS_PENDING: 'pending',
  UPDATE_STATUS_CURRENT: 'current',
  UPDATE_STATUS_FAILED: 'current',
  UPDATE_STATUS_ESTIMATED: 'current',
  UPDATE_STATUS_UNAVAILABLE: 'current',
} as const;

export const priceUpdateStatusMap: UpdateStatusMap = {
  UPDATE_STATUS_PENDING: 'pending',
  UPDATE_STATUS_CURRENT: 'current',
  UPDATE_STATUS_FAILED: 'failed',
  UPDATE_STATUS_ESTIMATED: 'estimated',
  UPDATE_STATUS_UNAVAILABLE: 'unavailable',
} as const;

export const mapUpdateStatus = (
  updateStatusMap: UpdateStatusMap,
  updateStatus?: UpdateStatus,
): PriceStatus => {
  if (!updateStatus || updateStatus === sonarUpdateStatus.UPDATE_STATUS_UNSPECIFIED) {
    throw new Error(`Unexpected Sonar V3 updateStatus: ${updateStatus}`);
  }
  return updateStatusMap[updateStatus];
};
